import api from "./api";

const ENABLE_API_TRACE = false; // Mapeia as chamadas da API no console

export default class BaseService {
  constructor() {
    this.trace = (url, method) => {
      console.groupCollapsed(`URL => ${url} (${method})`);
      console.trace();
      console.groupEnd();
    };
    if (this.constructor == BaseService) {
      throw new Error("Não é possivel criar uma instancia do serviço base");
    }
  }
  list() {
    if (ENABLE_API_TRACE) this.trace(`${this.url}`, "get");
    return api.get(`${this.url}`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  listByUserId() {
    if (ENABLE_API_TRACE) this.trace(`${this.url}`, "get");

    return api.get(`${this.url}`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  search(id) {
    if (ENABLE_API_TRACE) this.trace(`${this.url}/${id}`, "get");
    console.log(this.url)
    return api.get(`${this.url}/${id}`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  searchByUserId(id) {
    if (ENABLE_API_TRACE) this.trace(`${this.url}/${id}`, "get");
    return api.get(`${this.url}/${id}`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  update(element, post) {
    console.log(post === true)
    if (post === true) {
      if (ENABLE_API_TRACE) this.trace(`${this.url}`, "put");
      return api.post(`${this.url}`, element).then(
        (res) => res.data,
        (err) => {
          console.log(err);
          throw new Error(err.message);
        }
      );
    }

    if (element.id) {
      if (ENABLE_API_TRACE) this.trace(`${this.url}/${element.id}`, "put");
      return api.put(`${this.url}/${element.id}`, element);
    } else {
      if (ENABLE_API_TRACE) this.trace(`${this.url}`, "put");
      return api.post(`${this.url}`, element).then(
        (res) => res.data,
        (err) => {
          console.log(err);
          throw new Error(err.message);
        }
      );
    }
  }

  erase(element) {
    if (ENABLE_API_TRACE) this.trace(`${this.url}/${element.id}`, "erase");

    const id = element.id ?? element.jobId;

    if (id == null) {
      throw new Error("element.id e element.jobId não foram informados");
    }

    return api.delete(`${this.url}/${id}`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  async listByPagination(skip, take, userId) {
    try {
      const path =
        userId == null
          ? `${this.url}/${skip}/${take}`
          : `${this.url}/${skip}/${take}/${encodeURIComponent(userId)}`;

      const { data } = await api.get(path);
      return data;
    } catch (err) {
      console.error(err);
      throw new Error(err?.message ?? "Request failed");
    }
  }
}
